import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";
import { env } from "../config/env";

export const oidcSettings: UserManagerSettings = {
  authority: env.authServer,
  client_id: env.clientId,
  redirect_uri: `${window.location.origin}/auth-callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: "code",
  scope: env.scope,
  filterProtocolClaims: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/assets/silent-refresh.html`,
};
